var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"13","viewBox":"0 0 12 13","fill":"#383838","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"12","height":"3","y":"5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }